/* Progressive enhancements using event delegation so Ajax/infinite-scroll cards also work. */
(() => {
  'use strict';
  const photoPreferenceKey = 'hz_photo_mode';
  const dialogSupported = typeof HTMLDialogElement !== 'undefined';
  const cssEscape = (s) => (window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/[^a-zA-Z0-9_-]/g, ''));

  function setPhotoMode(mode, persist = true) {
    if (mode !== 'model' && mode !== 'flatlay') return;
    document.body.dataset.hzPhotoMode = mode;
    document.querySelectorAll('[data-hz-photo-button]').forEach(button => {
      const selected = button.dataset.hzPhotoButton === mode;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    if (persist) {
      try { sessionStorage.setItem(photoPreferenceKey, mode); } catch (_) {}
    }
  }
  try { setPhotoMode(sessionStorage.getItem(photoPreferenceKey) || 'flatlay', false); }
  catch (_) { setPhotoMode('flatlay', false); }

  // Sections can be replaced after applying filters; keep the visible pill synchronized
  // without reloading the page and without observing attribute changes we make ourselves.
  const syncPhotoButtons = () => setPhotoMode(document.body.dataset.hzPhotoMode || 'flatlay', false);
  let photoControlsObserver;
  const watchPhotoButtons = () => {
    if (photoControlsObserver) { syncPhotoButtons(); return; }
    let scheduled = false;
    photoControlsObserver = new MutationObserver((records) => {
      // Ajax filter render can replace the entire collection section or toolbar.
      if (!records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.('[data-hz-photo-control]') || node.querySelector?.('[data-hz-photo-control]'))))) return;
      if (scheduled) return;
      scheduled = true;
      queueMicrotask(() => { scheduled = false; syncPhotoButtons(); });
    });
    photoControlsObserver.observe(document.body, { childList: true, subtree: true });
    syncPhotoButtons();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchPhotoButtons, { once: true });
  else watchPhotoButtons();

function ensureVideoDialog() {
  let dialog = document.querySelector('#hz-video-dialog');
  if (dialog) return dialog;

  dialog = document.createElement('dialog');
  dialog.id = 'hz-video-dialog';
  dialog.className = 'hz-video-dialog';
  dialog.setAttribute('aria-label', 'See it live product video');
  dialog.innerHTML = `
    <div class="hz-video-dialog__content" data-hz-video-content></div>
    <div class="hz-video-dialog__controls">
      <button type="button" class="hz-video-dialog__control" data-hz-video-audio aria-label="Turn sound on" aria-pressed="false">
        <span data-hz-video-sound-label>Sound off</span>
      </button>
      <button type="button" class="hz-video-dialog__control" data-hz-video-close aria-label="Close video">
        <span aria-hidden="true" class="hz-video-dialog__cross">×</span> Close
      </button>
    </div>`;
  document.body.appendChild(dialog);
  dialog.addEventListener('close', () => {
    dialog.querySelectorAll('video').forEach(video => {
      video.pause();
      try { video.currentTime = 0; } catch (_) {}
    });
    dialog.querySelector('[data-hz-video-content]').replaceChildren();
  });
  // Clicking outside the picture also closes the viewer on desktop.
  dialog.addEventListener('click', event => {
    if (event.target === dialog) dialog.close();
  });
  return dialog;
}

  function recommendSize(guide, height, weight) {
    const permitted = new Set(['S', 'M', 'L', 'XL']);
    let sizes;
    try { sizes = JSON.parse(guide.dataset.availableSizes || '[]'); } catch (_) { sizes = []; }
    const available = [...new Set(sizes.map(s => String(s).trim().toUpperCase()))].filter(s => permitted.has(s));
    if (!available.length) return { message: 'There are currently no available sizes to recommend.' };

    // An optional per-product JSON metafield calibrates the recommendation to this garment.
    // Example: { "S":{"max_height":165,"max_weight":58}, "M":{"max_height":175,"max_weight":73},
    //            "L":{"max_height":185,"max_weight":88}, "XL":{"max_height":210,"max_weight":180} }
    let rules = null;
    try { rules = JSON.parse(guide.dataset.sizeRules || 'null'); } catch (_) {}
    let suggested;
    const ordered = ['S', 'M', 'L', 'XL'];
    if (rules && typeof rules === 'object' && !Array.isArray(rules) && Object.keys(rules).length) {
      suggested = ordered.find(size => {
        const rule = rules[size] || rules[size.toLowerCase()];
        if (!rule || typeof rule !== 'object') return false;
        return height >= Number(rule.min_height ?? 0) && height <= Number(rule.max_height ?? 999) &&
          weight >= Number(rule.min_weight ?? 0) && weight <= Number(rule.max_weight ?? 999);
      });
      if (!suggested) return { message: 'No size matches these measurements under this item’s fit rules. Check the measurements chart.' };
    } else {
      // Clearly marked generic estimate: brands and silhouettes require calibrated rules for reliability.
      const h = height <= 165 ? 0 : height <= 175 ? 1 : height <= 185 ? 2 : 3;
      const w = weight <= 58 ? 0 : weight <= 73 ? 1 : weight <= 88 ? 2 : 3;
      suggested = ordered[Math.max(h, w)];
    }
    if (!available.includes(suggested)) {
      return { message: 'Your estimated fit is not currently available. Check back for restocks or view the size chart.' };
    }
    return { size: suggested, calibrated: !!(rules && Object.keys(rules).length) };
  }

  function updateDeliveryDates(scope = document) {
    scope.querySelectorAll('[data-hz-delivery]').forEach(element => {
      const days = Math.max(1, Math.min(21, Number(element.dataset.days) || 3));
      const date = new Date();
      date.setHours(12, 0, 0, 0); // noon avoids daylight-saving boundary date jumps
      date.setDate(date.getDate() + days);
      const locale = document.documentElement.lang || 'en';
      const formatted = new Intl.DateTimeFormat(locale, { weekday: 'short', month: 'short', day: 'numeric' }).format(date);
      const holder = element.querySelector('[data-hz-date]');
      if (holder) holder.textContent = formatted;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => updateDeliveryDates(), {once:true});
  else updateDeliveryDates();
  document.addEventListener('shopify:section:load', () => { updateDeliveryDates(); watchPhotoButtons(); syncPhotoButtons(); });

  document.addEventListener('click', (event) => {
    const photoButton = event.target.closest('[data-hz-photo-button]');
    if (photoButton) { event.preventDefault(); setPhotoMode(photoButton.dataset.hzPhotoButton); return; }

const openVideo = event.target.closest('[data-hz-open-video]');
if (openVideo) {
  event.preventDefault();
  event.stopPropagation();
  // Each PDP button reads its own product-specific video, never a collection card.
  const productVideo = openVideo.closest('[data-hz-product-video]');
  const template = productVideo?.querySelector('template[data-hz-video-template]');
  if (!template || !dialogSupported) return;
  const dialog = ensureVideoDialog();
  const content = dialog.querySelector('[data-hz-video-content]');
  content.replaceChildren(template.content.cloneNode(true));
  const video = content.querySelector('video');
  if (!video) return;
  video.muted = true;
  video.controls = false;
  video.loop = true;
  video.playsInline = true;
  const audio = dialog.querySelector('[data-hz-video-audio]');
  audio.setAttribute('aria-pressed', 'false');
  audio.setAttribute('aria-label', 'Turn sound on');
  audio.querySelector('[data-hz-video-sound-label]').textContent = 'Sound off';
  if (!dialog.open) dialog.showModal();
  video.play().catch(() => { video.controls = true; });
  return;
}
const soundButton = event.target.closest('[data-hz-video-audio]');
if (soundButton) {
  event.preventDefault();
  const video = soundButton.closest('dialog')?.querySelector('video');
  if (!video) return;
  video.muted = !video.muted;
  const isSoundOn = !video.muted;
  soundButton.setAttribute('aria-pressed', String(isSoundOn));
  soundButton.setAttribute('aria-label', isSoundOn ? 'Turn sound off' : 'Turn sound on');
  soundButton.querySelector('[data-hz-video-sound-label]').textContent = isSoundOn ? 'Sound on' : 'Sound off';
  return;
}
const closeVideo = event.target.closest('[data-hz-video-close]');
if (closeVideo) { event.preventDefault(); closeVideo.closest('dialog')?.close(); return; }

    const colorButton = event.target.closest('[data-hz-color]');
    if (colorButton) {
      event.preventDefault(); event.stopPropagation();
      const card = colorButton.closest('product-card');
      if (!card) return;
      card.querySelectorAll('[data-hz-color]').forEach(option => {
        const selected = option === colorButton;
        option.classList.toggle('is-selected', selected);
        option.setAttribute('aria-pressed', String(selected));
      });
      // Update product destination to the corresponding color variant.
      const link = card.querySelector('a.product-card__link');
      if (link && colorButton.dataset.variantUrl) link.href = colorButton.dataset.variantUrl;
      const quickAdd = card.querySelector('quick-add-component');
      if (quickAdd && quickAdd.dataset.productOptionsCount !== '0') quickAdd.dataset.quickAddButton = 'choose';
      const galleryLink = card.querySelector('.card-gallery a.contents');
      if (galleryLink && colorButton.dataset.variantUrl) galleryLink.href = colorButton.dataset.variantUrl;
      // Preview the variant image without changing gallery component's internal variant state.
      const imageUrl = colorButton.dataset.variantImage;
      if (imageUrl) {
        card.classList.add('hz-color-preview');
        const target = card.querySelector('.card-gallery .product-media-container img');
        if (target) { target.removeAttribute('srcset'); target.removeAttribute('sizes'); target.src = imageUrl; }
      }
      return;
    }
    const openSize = event.target.closest('[data-hz-size-open]');
    if (openSize) { event.preventDefault(); if (dialogSupported) openSize.closest('.hz-size-guide')?.querySelector('dialog')?.showModal(); return; }
    const closeSize = event.target.closest('[data-hz-close]');
    if (closeSize) { event.preventDefault(); closeSize.closest('dialog')?.close(); }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.hz-size-dialog__form');
    if (!form) return;
    event.preventDefault();
    const height = Number(form.querySelector('[data-hz-height]')?.value);
    const weight = Number(form.querySelector('[data-hz-weight]')?.value);
    const result = form.closest('.hz-size-dialog').querySelector('[data-hz-size-result]');
    if (!Number.isFinite(height) || !Number.isFinite(weight) || height < 140 || height > 210 || weight < 35 || weight > 180) {
      result.textContent = 'Enter a height between 140–210 cm and weight between 35–180 kg.';
      return;
    }
    const guide = form.closest('[data-hz-size-guide]');
    const suggestion = recommendSize(guide, height, weight);
    result.replaceChildren();
    if (suggestion.size) {
      const label = document.createElement('span'); label.textContent = 'Your estimated size';
      const size = document.createElement('strong'); size.textContent = suggestion.size;
      const note = document.createElement('span'); note.textContent = suggestion.calibrated ? 'Based on this product’s fitted size profile.' : 'General starting-point estimate — check the item measurements.';
      result.append(label, size, note);
    } else result.textContent = suggestion.message;
  });
})();
